import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { OccupationalDoctorService } from '@/infra/services/occupational-doctor';

interface GetOccupationalDoctorParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = OccupationalDoctorService.getInstance();

export const useGetOccupationalDoctor = (params: GetOccupationalDoctorParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id, params.id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_OCCUPATIONAL_DOCTOR, params],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
